<template>
  <div class="main-content" @click="closeCalendar">

    <OrderInvoicesBlock/>

    <div class="card">
      <div class="card-body">
        <form @submit.prevent="search(1)" class="fs-12">
          <SearchFilter ref="searchFilter"
                        :page="paginator && paginator.current_page || 1"
                        :search="search"/>

          <div class="text-right">
            <vue-ladda button-class="btn btn-info"
                       type="submit"
                       data-style="zoom-in"
                       :loading="loading">Поиск
            </vue-ladda>
          </div>
        </form>
      </div>
    </div>

    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>

    <div class="card" v-if="!loading && searchRecordsShow">
      <div class="card-body">
        <template v-if="!records || !records.length">
          <h4>Препаратов не найдено</h4>
        </template>
        <template v-else>
          <div class="flex justify-content-between">
            <div v-if="paginator">
              <paginate
                v-model="paginator.current_page"
                :page-count="paginator.last_page"
                :page-range="10"
                :margin-pages="2"
                :click-handler="search"
                :prev-text="'&laquo'"
                :next-text="'&raquo'"
                :container-class="'pagination'"
                :prev-class="'page-item'"
                :prev-link-class="'page-link'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :next-class="'page-item'"
                :next-link-class="'page-link'"
                :active-class="'active green_btn'">
              </paginate>
            </div>
<!--            <div>-->
<!--              <vue-ladda @click="updateRecords()" button-class="btn btn-info"-->
<!--                         data-style="zoom-in"-->
<!--                         :loading="saveLoading">Сохранить-->
<!--              </vue-ladda>-->
<!--            </div>-->
          </div>

          <DrugsList
            ref="drugsList"
            :getActiveDrug="(drugData) => this.getActiveDataFromSite(drugData)"
            :drugLinks="drugLinks"
            :records="records"
            :fixedDates="true"
            :hideBlocks="{priceEdit: true}"
            :drugsOrdered="ordered"
            :invoices="invoices"
            :freezeInvoices="freezeInvoices"
            :ordersStat="ordersStat"
            :soldData="soldData"
            :storeDrugData="storeDrugData"
            :profitCalculation="{...$refs.searchFilter.profitCalculation, countryId: +$refs.searchFilter.filter.type === 4 ? $refs.searchFilter.filter.searchData : null}"
          />

          <hr>
          <div class="flex justify-content-between">
            <div v-if="paginator">
              <paginate
                v-model="paginator.current_page"
                :page-count="paginator.last_page"
                :page-range="10"
                :margin-pages="2"
                :click-handler="search"
                :prev-text="'&laquo'"
                :next-text="'&raquo'"
                :container-class="'pagination'"
                :prev-class="'page-item'"
                :prev-link-class="'page-link'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :next-class="'page-item'"
                :next-link-class="'page-link'"
                :active-class="'active green_btn'">
              </paginate>
            </div>
<!--            <div>-->
<!--              <vue-ladda @click="updateRecords()" button-class="btn btn-info"-->
<!--                         data-style="zoom-in"-->
<!--                         :loading="saveLoading">Сохранить-->
<!--              </vue-ladda>-->
<!--            </div>-->
          </div>

        </template>
      </div>
    </div>

  </div>
</template>

<script>

import api from '@/api'
import SearchFilter from './components/Filter'
import SearchResult from "./components/SearchResult";
import VueLadda from 'vue-ladda/src/vue-ladda.vue';
import Paginate from 'vuejs-paginate';
import DrugsList from './components/DrugsList'
import OrderInvoicesBlock from "@/views/nomenclature/components/OrderInvoicesBlock";

export default {
  title: 'Синхронизация',
  components: {
    SearchFilter,
    SearchResult,
    VueLadda,
    DrugsList,
    Paginate,
    OrderInvoicesBlock,
  },
  data() {
    return {
      drugLinks: {},
      loadingColor: this.$constants.LOADING_COLOR,
      loading: false,
      saveLoading: false,
      records: null,
      freezeInvoices: {},
      invoices: {},
      paginator: null,
      searchRecordsShow: false,
      extraData: {},
      monthIndex: {},
      ordersStat: {},
      soldData: {},
      storeDrugData: {},
      ordered: {},
    }
  },
  computed: {
    $AllProjects() {
      const stores = this.$store.getters['platform/projects'].filter((s) => s.id !== 4)
      return _.orderBy(stores, 'id');
    },
  },
  methods: {
    async getActiveDataFromSite(drugData) {
      if (!this.drugLinks[drugData.projectId]) this.drugLinks[drugData.projectId] = {};
      if (!this.drugLinks[drugData.projectId][drugData.drugId]) {
        this.drugLinks[drugData.projectId][drugData.drugId] = {
          success: false,
          link: null,
          loading: false
        };
        this.drugLinks = {...this.drugLinks};
      }
      this.drugLinks[drugData.projectId][drugData.drugId].loading = true;
      const {data} = await api.post('/new/drugs/infoType', {
        types: ['projectInfo'],
        drug_id: drugData.drugId,
        project_id: drugData.projectId
      })
      this.drugLinks[drugData.projectId][drugData.drugId].success = data.success;
      this.drugLinks[drugData.projectId][drugData.drugId].link = data.link;
      this.drugLinks[drugData.projectId][drugData.drugId].message = data.message;

      this.drugLinks[drugData.projectId][drugData.drugId].loading = false;
      this.drugLinks = {...this.drugLinks}
    },
    getFilterValue(key, field = null) {
      return field ? this.$refs.searchFilter[field] : this.$refs.searchFilter.filter[key];
    },
    async updateRecords() {
      // const updateData = this.$refs.searchResult.updateData;
      const updateData = this.$refs.drugsList.toUpdate;
      if (!Object.keys(updateData).length) return;
      this.saveLoading = true;
      let {data} = await api.post('/nomenclature/updatedrugs', {updateData});
      if (!data.success) {
        toastr['error'](data.message || 'Синхронизация не выполнена', 'Ошибка')
      } else {
        this.$refs.drugsList.toUpdate = {};
        toastr['success'](data.message || 'Сохранено', 'Успешно')
        await this.search();
      }
      this.saveLoading = false;
    },
    async search(p = null) {
      // this.$refs.searchResult.updateData = {};
      let page
      if (p) {
        page = p
      } else {
        page = this.paginator && this.paginator.current_page || 1;
      }
      // this.$refs.searchFilter.updateUrl();
      this.records = null;
      this.paginator = null;
      this.loading = true;
      this.searchRecordsShow = true;
      this.$refs.searchFilter.updateFilter(page);
      let {data: r_data} = await api.post('/nomenclature/synchronize', {
        page: page,
        useFixedDates: true,
        filter: this.$refs.searchFilter.filter
      })
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        // this.extraData = r_data.extraData;
        // this.monthIndex = r_data.monthIndex;
        this.ordered = r_data.ordered.reduce((acc, o) => {
          if (!acc[o.drug_id]) acc[o.drug_id] = [];
          acc[o.drug_id].push(o)
          return acc;
        }, {})
        this.invoices = r_data.invoices;
        this.ordersStat = r_data.ordersStat;
        this.soldData = r_data.soldData;
        this.storeDrugData = r_data.storeDrugData;
        this.freezeInvoices = r_data.freezeInvoices;
        this.records = data.reduce((acc, r) => {
          r.prices = r.prices.reduce((ac, p) => {
            ac.push({...p, price: p.price * r.pack_set})
            return ac
          }, [])
          r.details.forEach((d, i) => {
            if (d.group_alias === 'egk' && d.alias === 'id') {
              const egk = r_data.egkCodes.find((c) => c.id === d.int_value);
              if (egk) {
                r.details[i].invalid = egk.invalid;
              }
            }
          })
          acc.push(r)
          return acc
        }, []);
      }
      this.loading = false;
    },
    closeCalendar(e) {
      if (e.target.classList.contains('calendarAction') || e.target.classList.contains('prev') || e.target.classList.contains('next')) return;
      if (this.$refs.searchFilter && this.$refs.searchFilter.$refs.searchValue) {
        this.$refs.searchFilter.$refs.searchValue.calendarOpen = false;
      }
      if (this.$refs.searchFilter && this.$refs.searchFilter.$refs.calendar) {
        this.$refs.searchFilter.$refs.calendar.showDayView = false;
      }
    },
  },
}

</script>

<style scoped>
.fs-12 {
  font-size: 12px;
}
</style>
